import React,{useEffect,useState} from 'react';
import {useLocation,useNavigate,useParams} from 'react-router-dom';
import {doc,getDoc} from 'firebase/firestore';
import {db} from '../../Security/firebase-config';
import {recordWorkspaceRoute} from './recordWorkspaceRoute';

// Retain standalone tools for unlinked/older records. Redirect only after the
// server-readable event and its current map binding have both been verified.
export default function LinkedRecordEntry({teamId,kind='vod',children}){
  const location=useLocation(),navigate=useNavigate(),path=useParams(),params=new URLSearchParams(location.search);
  const id=kind==='stats'?params.get('match'):path.videoId||params.get('video'),mapId=path.mapId||params.get('map');
  const identity=JSON.stringify([teamId,kind,id,mapId,location.search]),[state,setState]=useState(null);
  useEffect(()=>{
    if(!teamId||!id||(kind==='vod'&&!mapId))return undefined;
    let alive=true;
    (async()=>{
      try{
        const parts=kind==='vod'?['maps',mapId,'videos',id]:['matches',id];
        const snapshot=await getDoc(doc(db,'teams',teamId,...parts));
        if(!alive)return;
        if(!snapshot.exists()){setState({identity});return;}
        let record={...snapshot.data(),id:snapshot.id};
        if(!record.calendarEventId&&kind==='vod'&&record.matchId){const match=await getDoc(doc(db,'teams',teamId,'maps',mapId,'matches',record.matchId));if(match.exists())record={...record,calendarEventId:match.data().calendarEventId};}
        const team=await getDoc(doc(db,'teams',teamId));
        if(!alive)return;
        const route=team.exists()?recordWorkspaceRoute({teamId,team:team.data(),record,kind,mapId,contextSearch:location.search}):null;
        if(route){navigate(route,{replace:true});return;}
        setState({identity});
      }catch{if(alive)setState({identity});}
    })();
    return()=>{alive=false;};
  },[identity,teamId,id,mapId,kind,navigate,location.search]);
  if(teamId&&id&&(kind==='stats'||mapId)&&state?.identity!==identity)return <p role="status">Opening the linked event or recording…</p>;
  return children;
}
